<template>
    <div>
        <v-simple-table v-if="logs.length" id="user-detail-expand-table">
            <thead>
            <tr>
                <th>Be</th>
                <th>Ki</th>
                <th>Idő</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in logs" :key="row.in" :class="row._rowVariant">
                <td>{{ row.in }}</td>
                <td>{{ row.out }}</td>
                <td>{{ row.time }}</td>
            </tr>
            </tbody>
        </v-simple-table>
        <v-alert v-else border="right" color="warning" :prominent="true" icon="mdi-briefcase-remove">
            Ezen a napon nem volt aktivitás az alkalmazott részéről.
        </v-alert>
    </div>
</template>

<script>
    export default {
        name: "UserDetailDailyLog",

        props: {
            logs: {
                required: true,
            }
        }
    }
</script>

<style lang="scss">
    #user-detail-expand-table thead tr:last-child th {
        height: 30px;
        background: #efefef;
        text-align: center;
    }

    #user-detail-expand-table tbody tr td {
        height: 30px;
        text-align: center;
    }
</style>